/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames } from '../CapNames';
import { Orientation } from '../Orientation';
import { AmbientLight, SpotLight, PointLight } from 'three';
/**
 * Type of Light
 */
export var LightType;
(function (LightType) {
    LightType["AMBIENT"] = "ambient";
    LightType["POINT"] = "point";
    LightType["SPOT"] = "spot";
})(LightType || (LightType = {}));
/**
 * Capability to add light sources
 */
export class LightCap {
    getName() {
        return CapNames.LIGHT;
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (!!payload.lightType && !!payload.color) {
            let light;
            switch (payload.lightType) {
                case LightType.AMBIENT:
                    light = new AmbientLight(payload.color, payload.intensity);
                    break;
                case LightType.SPOT:
                    light = new SpotLight(payload.color, payload.intensity, payload.distance, payload.angle, payload.exponent, payload.decay);
                    light.penumbra = payload.penumbra || 0.05;
                    if (!!payload.targetid) {
                        const object = sceneIn.getObjectById(payload.targetid);
                        if (!!object) {
                            light.target = object;
                        }
                    }
                    break;
                case LightType.POINT:
                default:
                    light = new PointLight(payload.color, payload.intensity, payload.distance, payload.decay);
                    break;
            }
            if (payload.lightType !== 'ambient' && !!payload.castShadow) {
                light.castShadow = payload.castShadow;
            }
            light.name = objectIn.name;
            Orientation.set(light, objectIn);
            sceneIn.add(light);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=LightCap.js.map